import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 40 }) => {
  const { t } = useTranslation('localizable');
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      role="status"
      aria-live="polite"
      aria-label={t('Loading')}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
